<template>
  <div class="md-skel" :aria-hidden="true">
    <template v-if="variant === 'kpi'">
      <div class="md-skel__primary"></div>
      <div class="md-skel__grid">
        <div v-for="n in 6" :key="n" class="md-skel__card"></div>
      </div>
    </template>
    <div v-else-if="variant === 'chart'" class="md-skel__chart"></div>
    <template v-else>
      <div v-for="n in rows" :key="n" class="md-skel__row"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MdSkeleton',
  props: {
    variant: { type: String, default: 'list' }, // kpi | chart | list
    rows: { type: Number, default: 4 },
  },
};
</script>

<style scoped>
.md-skel__primary,
.md-skel__card,
.md-skel__chart,
.md-skel__row {
  background: linear-gradient(90deg, rgba(140, 148, 160, 0.12) 25%, rgba(140, 148, 160, 0.22) 50%, rgba(140, 148, 160, 0.12) 75%);
  background-size: 200% 100%;
  animation: md-skel-shimmer 1.2s infinite linear;
  border-radius: 10px;
}
.md-skel__primary {
  height: 84px;
  margin-bottom: 0.75rem;
}
.md-skel__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem;
}
.md-skel__card { height: 74px; }
.md-skel__chart { height: 220px; }
.md-skel__row {
  height: 52px;
  margin-bottom: 0.5rem;
}
@keyframes md-skel-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
